/* tslint:disable */
/* eslint-disable */
// <auto-generated>
//   Generated using custom tool!
// </auto-generated>

import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios';
import { DefaultAxiosInstance } from './DefaultAxiosInstance';
import { Try } from 'framework/Try';

export async function meta_build(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<number>> {
	try {
		let url_ = '/api/meta/build';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_ping(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<void>> {
	try {
		let url_ = '/api/meta/ping';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function meta_url(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<string>> {
	try {
		let url_ = '/api/meta/url';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function settingsCommand_set(body: IPrinterSettingsModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IValidateResponse>> {
	try {
		let url_ = '/api/SettingsCommand/set';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_ = <AxiosRequestConfig>{
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function settingsQuery_get(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IPrinterSettings>> {
	try {
		let url_ = '/api/SettingsQuery/get';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function settingsQuery_isConfigured(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<boolean>> {
	try {
		let url_ = '/api/SettingsQuery/isConfigured';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function thermalPrinter_printers(instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IThermalPrinter[]>> {
	try {
		let url_ = '/api/ThermalPrinter/printers';
		url_ = url_.replace(/[?&]$/, '');

		let options_ = <AxiosRequestConfig>{
			method: 'GET',
			url: url_,
			headers: {
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export async function thermalPrinter_print(body: IPrintModel, instance: AxiosInstance = DefaultAxiosInstance()): Promise<Try<IUnit>> {
	try {
		let url_ = '/api/ThermalPrinter/print';
		url_ = url_.replace(/[?&]$/, '');

		const content_ = JSON.stringify(body);

		let options_ = <AxiosRequestConfig>{
			data: content_,
			method: 'POST',
			url: url_,
			headers: {
				'Content-Type': 'application/json-patch+json',
				Accept: 'text/plain',
			},
		};

		const r = await instance.request(options_).then((response: AxiosResponse) => response.data);
		return new Try(r);
	} catch (error) {
		return new Try(undefined as any, error);
	}
}

export interface IPrinterSettingsModel {
	printerName: string | undefined;
	paperSizeName: string | undefined;
}

export interface IValidateResponse {
	error: string;
	hasError: boolean;
}

export interface IPrinterSettings {
	printerName: string | undefined;
	paperSizeName: string | undefined;
}

export interface IThermalPrinter {
	name: string | undefined;
	paperSources: string[];
}

export interface ISalesLineDto {
	description: string | undefined;
	linePriceInVat: number;
}

export interface IVatSplit {
	percentage: number;
	amountInVat: number;
	value: number;
	amountExVat: number;
}

export interface ICashSaleDto {
	date: Date;
	reference: string | undefined;
	location: string | undefined;
	lines: ISalesLineDto[];
	vatSplits: IVatSplit[];
	priceInVat: number;
	priceExVat: number;
	vatAmount: number;
}

export interface IBusinessDataDto {
	companyName: string | undefined;
	vatNumber: string | undefined;
	website: string | undefined;
	addressLine: string | undefined;
	zip: string | undefined;
	city: string | undefined;
	phone: string | undefined;
	email: string | undefined;
}

export interface ISalesTicket {
	sale: ICashSaleDto;
	businessData: IBusinessDataDto;
	logo: string | undefined;
}

export interface IPrintModel {
	printerName: string | undefined;
	paperSizeName: string | undefined;
	data: ISalesTicket;
}

export interface IUnit {}
